module.exports = __webpack_public_path__ + "img/community.bc1ac226.svg";